<template>
  <div class="container">
    <div class="df no-pro" v-show="length==0">
      <img src="../../assets/img/home_default.png" alt="">
      <p>你没有发布任何作品<br />快来和我们一起分享吧~</p>
      <!--<router-link tag="div" class="share-btn" to="/share">分享作品</router-link>-->
    </div>
    <div v-if="isWaterShow">
        <water-fall @getListLength="getListLength" v-show="length>0" :uId="userInfo.Id" :sType="sType"></water-fall>
    </div>
  </div>
</template>
<script>
import WaterFall from "../common/waterfall.vue"
export default {
  props: ['userInfo'],
  data() {
    return {
      length: 0,
      sType: 0,
      isWaterShow: true,
    }
  },
  created(){
    this.getQuery();
  },
  components: {
    WaterFall
  },
  methods: {
    getListLength(len) {
      this.length = len;
    },
    getQuery(){
      let type = this.$route.query.sourceType;
      if(type==1 || type==2 || type==3){
        this.sType = type;
      }else{
        this.sType = 2;
      }
      this.$emit("getNavIndex",this.sType);
    }
  },
  watch: {
    sType(){
      this.isWaterShow = false;
      setTimeout(()=>{
        this.isWaterShow = true;
      },200)
    },
    $route(){
      this.getQuery();
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fbfbfb;
  min-height: 400px;
}

.no-pro {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  text-align: center;
  min-height: 600px;
}

.no-pro img {
  margin-top: 6%;
}

.no-pro p {
  font-size: 18px;
  line-height: 28px;
  margin-top: 2%;
}

.share-btn {
  width: 286px;
  line-height: 38px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #ff9933;
  box-sizing: border-box;
  margin-top: 2%;
  cursor: pointer;
}

.share-btn:hover {
  color: #fff;
  background-color: #ff9933;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/original.vue